import { Module } from 'vuex';
import { IRootState, IStatsState, TAppStats } from '@types';
import * as moment from 'moment';
import { StatsApi } from '@/api';

const transformNomination = (item: any) => {
    return {
        id: item.id,
        date: moment(item.project?.start_at || item.date).format('YYYY-MM-DD'),
        name: item.project.title,
        type: item.projectType.title,
    };
};

const store: Module<IStatsState, IRootState> = {
    state: {
        appStats: <TAppStats>{
            voices: null,
            languages: null,
            voice_samples: null,
            music_categories: null,
            music_samples: null,
            music_hours: null,
            error: '',
        },
    },

    mutations: {
        setAppStats: (state, appStats: TAppStats) => (state.appStats = appStats),
    },

    getters: {
        getAppStats: (state): TAppStats => state.appStats,

        getActorStatsTableConfig() {
            return [
                {
                    id: 0,
                    caption: '',
                    type: 'text',
                    width: 0,
                    flex: 0,
                    hidden: true,
                },
                {
                    id: 1,
                    caption: 'Date',
                    type: 'text',
                    width: '70px',
                    flex: 0,
                    hidden: false,
                },
                {
                    id: 2,
                    caption: 'PROJECT NAME',
                    type: 'text',
                    width: 0,
                    flex: 2,
                    bold: true,
                    hidden: false,
                },
                {
                    id: 3,
                    caption: 'Type',
                    type: 'text',
                    width: 0,
                    flex: 0,
                    hidden: false,
                },
            ];
        },

        getActorWinList(state, getters, rootState, rootGetters) {
            return (
                rootGetters.getActor?.nominations?.filter((item: any) => !!item.contract).map(transformNomination) ?? []
            );
        },

        getActorShortList(state, getters, rootState, rootGetters) {
            return (
                rootGetters.getActor.nominations.filter((item: any) => !item.contract).map(transformNomination) ?? []
            );
        },
    },

    actions: {
        loadAppStats({ commit }): Promise<any> {
            return StatsApi.loadAppStats()
                .then((response) => {
                    commit('setAppStats', response.data);
                })
                .catch((err) => {
                    console.error(err);
                });
        },
    },
};

export default store;
